import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddExternalCertificateModel } from 'src/app/models/person/add-external-certificate.model';
import { PersonModel } from 'src/app/models/person/person.model';
import { TrainingTypeModel } from 'src/app/models/training/training-type.model';
import { ApprovalRequestService } from 'src/app/services/approval-request.service';
import { LoadingService } from 'src/app/services/loading.service';
import { PersonService } from 'src/app/services/person.service';
import { HttpStatusCode } from '@angular/common/http';
import { ApprovalRequestExternalCertificateCreationAndUpdateModel } from 'src/app/models/approval-request/approval-request-external-certificate-creation-and-update.model';

@Component({
  selector: 'app-submit-external-certificate-modal',
  standalone: false,
  templateUrl: './submit-external-certificate-modal.component.html',
  styleUrl: './submit-external-certificate-modal.component.scss'
})
export class SubmitExternalCertificateModalComponent implements OnInit {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Output() onClose = new EventEmitter();
  @Output() onSubmit = new EventEmitter();

  @Input() certificate!: AddExternalCertificateModel;
  TrainingType = TrainingTypeModel;

  confirmSubmitting: boolean = false;
  iddResponsiblePerson?: PersonModel | null;

  constructor(
    private loadingService: LoadingService,
    private approvalRequestService: ApprovalRequestService,
    private personService: PersonService
  ) {

  }

  ngOnInit() {
    this.loadingService
      .load(this.personService.getIddResponsiblePerson())
      .subscribe({
        next: (iddResponsiblePerson) => {
          this.iddResponsiblePerson = iddResponsiblePerson;
        },
        error: (err) => {
          if (err.status === HttpStatusCode.NotFound) {
            this.iddResponsiblePerson = null;
          } else {
            this.closeModal();
          }
        }
      });
  }

  submit() {
    const approvalRequest: ApprovalRequestExternalCertificateCreationAndUpdateModel = {
      name: this.certificate.name,
      description: this.certificate.description,
      date: this.certificate.date!,
      trainingType: this.certificate.trainingType!,
      iddTimeMinutes: this.certificate.iddTimeMinutes,
      location: this.certificate.location,
      trainingCategoryId: this.certificate.trainingCategoryId,
      certificateFile: this.certificate.certificateFile,
    };
    
    this.loadingService
      .load(this.approvalRequestService.addApprovalRequestExternalCertificate(approvalRequest))
      .subscribe(() => {
        this.closeModal();
        this.onSubmit.emit();
      });
  }

  cancel() {
    this.closeModal();
    this.onClose.emit();
  }

  private closeModal(){
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
